import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { formatDate, onConfirm } from 'Shared/helpers'
import { useWhsTerms } from '../whs_terms_context'

const t = (key, opts) => !window.I18n ? '' : window.I18n.t(key, opts)

const ScoreRow = ({ score, onDelete, formulaHtml, saving, readOnly }) => {
  const whsTerms = useWhsTerms()
  const [showFormula, setShowFormula] = useState(false)
  const diffDisplay = score.differential

  return (
    <>
      <tr>
        <td className='scores-table__col-date' data-label={t('member_handicap_history.common.date')}>
          <span className='score-row__date-top'>{formatDate(score.play_at, null, 'MMM D')}</span>
          <span className='score-row__date-year'>{formatDate(score.play_at, null, 'YYYY')}</span>
        </td>
        <td className='scores-table__col-course' data-label={t('member_handicap_history.common.course')}>{score.course}</td>
        <td className='scores-table__col-tee' data-label={t('member_handicap_history.common.tee')}>{score.tee}</td>
        <td className='scores-table__col-narrow' data-label={t('member_handicap_history.common.slope', whsTerms)}>{score.slope}</td>
        <td className='scores-table__col-narrow' data-label={t('member_handicap_history.common.rating', whsTerms)}>{score.rating}</td>
        <td className='scores-table__col-narrow' data-label={t('member_handicap_history.common.score')}><strong>{score.score}</strong></td>
        <td className='scores-table__col-narrow' data-label={t('member_handicap_history.scores_table.diff')}>{diffDisplay}</td>
        <td className='scores-table__col-narrow' data-label={t('member_handicap_history.common.holes')}>{score.game_type}</td>
        <td className='scores-table__col-actions score-row__actions'>
          {formulaHtml && (
            <button
              type='button'
              className={`hs-action-btn hs-action-btn--info${showFormula ? ' hs-action-btn--active' : ''}`}
              onClick={() => setShowFormula(v => !v)}
            >
              <i className='fa fa-info-circle' />
            </button>
          )}
          {!readOnly && (
            <button
              type='button'
              className='hs-action-btn hs-action-btn--danger'
              onClick={() => onConfirm(t('member_handicap_history.score_row.delete_confirm'), () => onDelete(score.id))}
              disabled={saving}
            >
              <i className='fa fa-trash' />
            </button>
          )}
        </td>
      </tr>
      {showFormula && formulaHtml && (
        <tr className='score-row__formula-row'>
          <td colSpan={9} className='score-row__formula'>
            {/* Formula HTML is generated by our internal HandicapServer, not user input */}
            <span dangerouslySetInnerHTML={{ __html: formulaHtml }} />
          </td>
        </tr>
      )}
    </>
  )
}

ScoreRow.defaultProps = {
  readOnly: false,
  onDelete: null,
}

ScoreRow.propTypes = {
  score: PropTypes.shape({
    id: PropTypes.string,
    play_at: PropTypes.string,
    course: PropTypes.string,
    tee: PropTypes.string,
    slope: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    rating: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    score: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    game_type: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    differential: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  }).isRequired,
  onDelete: PropTypes.func,
  formulaHtml: PropTypes.string,
  saving: PropTypes.bool,
  readOnly: PropTypes.bool,
}

export default ScoreRow
